module.exports = {
  VUE_APP_GOOGLE_TOKEN:
    process.env.VUE_APP_GOOGLE_TOKEN ||
    "AIzaSyDq22Tzh6Xi3Ypld1Am2bv0DnpvakbePwI",
  VUE_APP_API_URL: process.env.VUE_APP_API_URL || "http://localhost:4040/",
};
